export default __webpack_public_path__ + "static/media/paper24.61b95c58.JPG";